import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpClient, HttpStatusCode} from "@angular/common/http";
import RestHelper from "../../../../Helper/RestHelper";
import {RestResponse} from "../../../../Interfaces/RestResponse.interface";
import {Filterresponse} from "../../../../Interfaces/filterresponse.interface";
import {LoaderService} from "../../../../services/loader/loader.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Recruit} from "../../../../Interfaces/Recruit.interface";

@Component({
  selector: 'app-recruitform',
  templateUrl: './recruitform.component.html',
  styleUrl: './recruitform.component.css'
})
export class RecruitformComponent {

  public recruitform: FormGroup = this.formBuilder.group({
    useruuid: [""],
    title: ["", [Validators.required, Validators.minLength(4)]],
    description: ["", [Validators.required]],
    profilepdf: ["", [Validators.required]],
    zipcode: [""],
    city: [""],
    district: [""],
    contracttype: ["", [Validators.required]],
    timemodel: ["", [Validators.required]],
    remote: ["", [Validators.required]],
    salary: [""],
    industry: ["", [Validators.required]],
    startdate: ["", [Validators.required]],
    expirydate: [""],
    published: ["", [Validators.required]]
  })
  public sentstatus: number = 0

  public industry_filter: any;
  public contracttype_filter: any;
  public timemodel_filter: any;
  public remote_filter: any;

  public operation: string | undefined
  public uuid: string | undefined
  public recruit: Recruit | undefined

  public apierror: boolean = true

  constructor(private httpClient: HttpClient, private formBuilder: FormBuilder, protected loader: LoaderService, private route: ActivatedRoute, private router: Router) {
    this.loader.showLoader()
    this.route.params.subscribe(params => {
      this.operation = params['operation']
      this.uuid = params['uuid']
    });

    if (this.operation === "edit" || this.operation === "delete") {
      if (this.uuid === undefined) {
        //TODO Error UUID ist benötigt wenn create, update oder delete
        return
      }

      this.httpClient.get<RestResponse<Recruit>>(RestHelper.API_BASE_URL + "recruit/getRecruit?admin=true&uuid=" + this.uuid, RestHelper.requestOptions).subscribe({
        next: (value) => {
          console.log(value.data)

          this.recruit = value.data

          this.getFormControls()['useruuid'].setValue(this.recruit.useruuid)
          this.getFormControls()['title'].setValue(this.recruit.title)
          this.getFormControls()['description'].setValue(this.recruit.description)
          //TODO PDF Profilepdf
          this.getFormControls()['zipcode'].setValue(this.recruit.zipcode)
          this.getFormControls()['city'].setValue(this.recruit.city)
          this.getFormControls()['district'].setValue(this.recruit.district)
          this.getFormControls()['contracttype'].setValue(this.recruit.contract_type)
          this.getFormControls()['timemodel'].setValue(this.recruit.timemodel)
          this.getFormControls()['remote'].setValue(this.recruit.remote)
          this.getFormControls()['salary'].setValue(this.recruit.salary)
          this.getFormControls()['industry'].setValue(this.recruit.industry)
          this.getFormControls()['startdate'].setValue(this.recruit.start_date ? this.recruit.start_date.toString().split(" ")[0] : null)
          this.getFormControls()['expirydate'].setValue(this.recruit.expiry_date ? this.recruit.expiry_date.toString().split(" ")[0] : null)
          this.getFormControls()['published'].setValue(this.recruit.published ? "true" : "false")

          if (this.operation === "delete") {
            this.recruitform.disable()
          }

          this.loader.hideLoader()
          this.apierror = false
        }, error: () => {
          this.apierror = true
          this.loader.hideLoader()
        }
      })
    }

    this.httpClient.get<RestResponse<Filterresponse[]>>(RestHelper.API_BASE_URL + "searchfilter/getSearchFilter", RestHelper.requestOptions).subscribe({
      next: (value) => {

        this.industry_filter = value.data.filter(value1 => value1.filterName === "industry")?.at(0)?.filter
        this.contracttype_filter = value.data.filter(value1 => value1.filterName === "contract_type")?.at(0)?.filter
        this.timemodel_filter = value.data.filter(value1 => value1.filterName === "timemodel")?.at(0)?.filter
        this.remote_filter = value.data.filter(value1 => value1.filterName === "remote")?.at(0)?.filter

        this.loader.hideLoader()
        this.apierror = false
      }, error: () => {
        this.apierror = true
        this.loader.hideLoader()
      }
    })
  }

  public getOperation(): string {
    switch (this.operation) {
      case "create":
        return "Erstellen"
      case "edit":
        return "Bearbeiten"
      case "delete":
        return "Löschen"
    }
    return ""
  }

  public onSubmit() {
    if (this.operation === "edit") {
      this.recruitform.controls['profilepdf'].setValidators(null)
      this.recruitform.controls['profilepdf'].updateValueAndValidity()
    }
    if (!this.recruitform.valid) {
      this.recruitform.markAllAsTouched()
      for (let el in this.recruitform.controls) {
        if (this.recruitform.controls[el].errors) {
          console.log(el)
        }
      }
      console.log("Form Invalid")
      return;
    }

    const body = new FormData();
    body.append("useruuid", this.recruitform.value.useruuid)
    body.append("title", this.recruitform.value.title)
    body.append("description", this.recruitform.value.description)
    if (this.file) {
      body.append("profilepdf", this.file!, this.file?.name)
    }
    body.append("zipcode", this.recruitform.value.zipcode)
    body.append("city", this.recruitform.value.city)
    body.append("district", this.recruitform.value.district)
    body.append("contract_type", this.recruitform.value.contracttype)
    body.append("timemodel", this.recruitform.value.timemodel)
    body.append("remote", this.recruitform.value.remote)
    body.append("salary", this.recruitform.value.salary)
    body.append("industry", this.recruitform.value.industry)
    body.append("start_date", this.recruitform.value.startdate)
    body.append("expiry_date", this.recruitform.value.startdate)
    body.append("published", this.recruitform.value.published)
    body.append("uuid", String(this.uuid))

    console.log(body.get("description"))
    console.log(body.get("city"))

    if (this.operation === "create") {

      this.httpClient.post(RestHelper.API_BASE_URL + 'recruit/createRecruit', body, RestHelper.requestOptions)
        .subscribe({
          next: () => {
            this.sentstatus = 1
            this.recruitform.reset()
          },
          error: (err) => {
            this.sentstatus = err.status === HttpStatusCode.TooManyRequests ? 3 : 2
            console.error(err)
          }
        });
    } else if (this.operation === "edit") {

      this.httpClient.post(RestHelper.API_BASE_URL + 'recruit/updateRecruit', body, RestHelper.requestOptions)
        .subscribe({
          next: () => {
            this.sentstatus = 1
          },
          error: (err) => {
            this.sentstatus = err.status === HttpStatusCode.TooManyRequests ? 3 : 2
            console.error(err)
          }
        });
    }
  }

  public file: File | undefined

  public onFileUpload(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.file = file;
    }
  }

  public deleteRecruit(event: Event, uuid: string) {

    event.preventDefault()
    event.stopPropagation();

    const body = new FormData();

    body.append("uuid", uuid)

    this.httpClient.request("DELETE", RestHelper.API_BASE_URL + 'recruit/deleteRecruit', {body})
      .subscribe({
        next: () => {
          this.recruitform.reset()
          this.router.navigateByUrl('/admin/recruits').then(value => {
            if (!value) {
              console.error("Konnte nicht auf recruitübersicht umleiten")
            }
          })
        },
        error: (err) => {
          console.error(err)
        }
      });
  }

  public getFormControls() {
    return this.recruitform.controls;
  }

  protected readonly Validators = Validators;
}
